<template>
  <!--表头-->
  <table :border="printingDataChil3==1?1:0" rules="all" width="100%">
    <template v-if="printingDataChil3==1">
      <tr class="form-head" align="center">
        <td colspan="2" align="center">
          <h3>{{printingDataChil2.loginDataObj.schoolName}}</h3>
          <ul>
            <li>事务名称：{{printingDataChil2.loginDataObj.affairName}}</li>
            <li v-if="!(defaultPrintShowKey && defaultPrintShowKey.applicant === false)">
                申请人：{{printingDataChil2.loginDataObj.applyUser}}
            </li>
            <li v-if="isTime == 0 && !(defaultPrintShowKey && defaultPrintShowKey.time === false)">
              申请时间：{{formatTimestamp(printingDataChil2.loginDataObj.applyDate)}}
            </li>
          </ul>
        </td>
      </tr>
      <tr v-if="!(defaultPrintShowKey && defaultPrintShowKey.orders === false)">
        <td width="180">单号:</td>
        <td >{{printingDataChil2.orders}}</td>
      </tr>
    </template>
    <!--内容-->
    <template v-for="(trlist, index) in printingDataChil" :key="index">
      <template v-if="trlist.type == 'details'&&trlist.print==1" >
        <tr v-if="trlist.printOrientation === 'horizontal'">
          <td colspan="2">
            <div class="horizontal">
              <div class="horizontal-title">{{trlist.title}}</div>
              <table :border="printingDataChil3==1?1:0" rules="all" width="100%">
                <thead>
                  <tr>
                    <template v-for="item in (trlist.value[0] || [])">
                      <td v-if="item.print === 1 && item.type !== 'new-rel-radio'"
                          :key="item.key" class="details-header-td"
                          :width="item.width || '90px'"
                          :style="'width:' + (item.width || '90px') + ';min-width:' + (item.width || '90px')">
                        {{item.title}}
                      </td>
                      <template v-else-if="item.print === 1 && item.type === 'new-rel-radio'">
                        <template v-for="(its, index) in item.value" :key="index">
                          <td v-if="its.print === 1"
                              :key="'its' + its.key"
                              class="details-header-td"
                              :width="its.width || '90px'"
                              :style="'width:' + (its.width || '90px') + ';min-width:' + (its.width || '90px')">
                            {{its.title}}
                          </td>
                        </template>
                      </template>
                    </template>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in trlist.value" :key="i + '-' + item.key">
                    <template v-for="(list, index) in item" :key="index">
                      <td v-if="list.print === 1 && list.type === 'textarea'"
                          :width="list.width || '90px'"
                          :style="'width:' + (list.width || '90px') + ';min-width:' + (list.width || '90px')"
                          v-html="replaces(list.value)"></td>
                      <td v-else-if="list.print === 1 && list.type !== 'textarea' && list.type !== 'new-rel-radio'"
                          :key="'ls' + list.key"
                          :width="list.width || '90px'"
                          :style="'width:' + (list.width || '90px') + ';min-width:' + (item.width || '90px')">
                        <template v-if="list.type === 'checkbox'">
                          <div v-if="list.value == ''" style="width: 100%;align-content: center;">
                            （暂无数据）
                          </div>
                          <template v-else>
                            <span v-for="(tdlist, index) in list.value" :key="index" style="margin-right: 8px;">{{tdlist}}</span>
                          </template>
                        </template>
                        <template v-else-if="['relation-user', 'organization', 'roule'].includes(list.type)">
                          <div v-if="list.value == ''" style="width: 100%;align-content: center;">
                            （暂无数据）
                          </div>
                          <template v-else>
                            <span v-for="(tdlist, index) in list.value" :key="index" style="margin-right: 8px;">{{tdlist.realname || tdlist.name}}</span>
                          </template>
                        </template>
                        <template v-else-if="list.type === 'image'">
                          <div v-if="list.value==''" style="width: 100%;align-content: center;">
                            （未上传）
                          </div>
                          <template v-else>
                            <span v-for="tdlist in list.value"
                                  :key="tdlist"
                                  :style="{width: list.printWidth !== '100%' ? (list.printWidth + 'px') : '', height: (list.printHeight + 'px') || '', overflow:'hidden'}"
                                  class="td-span">
                              <img :src="$url+tdlist+token"
                                  :style="{maxWidth:'100%',maxHeight: '100%',width: trlist.printWidth !== '100%' ? (trlist.printWidth + 'px') : '',height: (trlist.printHeight + 'px') || ''}">
                            </span>
                          </template>
                        </template>
                        <template v-else-if="list.type === 'file'">
                          <div v-if="list.value==''" style="width: 100%;align-content: center;">
                            （未上传）
                          </div>
                          <template v-else>
                            <span v-for="tdlist in list.value" :key="tdlist.id" class="td-span">{{tdlist}}</span>
                          </template>
                        </template>
                        <template v-else-if="list.type === 'relation-radio'">
                          {{list.value}}
                        </template>
                        <template v-else>
                          {{list.value}}
                        </template>
                      </td>
                      <template v-else-if="list.print === 1 && list.type === 'new-rel-radio'">
                        <template v-for="its in list.value">
                          <td v-if="its.print === 1"
                              :key="'its' + its.key"
                              :width="its.width || '90px'"
                              :style="'width:' + (its.width || '90px') + ';min-width:' + (its.width || '90px')">
                            <template v-if="its.type === 'checkbox'">
                              <div v-if="its.value == ''" style="width: 100%;align-content: center;">
                                （暂无数据）
                              </div>
                              <template v-else>
                                <span v-for="(itss, index) in its.value" :key="index" style="margin-right: 8px;">{{itss}}</span>
                              </template>
                            </template>
                            <template v-else-if="['relation-user', 'organization', 'roule'].includes(itss.type)">
                              <div v-if="its.value == ''" style="width: 100%;align-content: center;">
                                （暂无数据）
                              </div>
                              <template v-else>
                                <span v-for="(itss, index) in its.value" :key="index" style="margin-right: 8px;">{{itss.realname || itss.name}}</span>
                              </template>
                            </template>
                            <template v-else>{{its.value}}</template>
                          </td>
                        </template>
                      </template>
                    </template>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
        </tr>
        <tr v-else :key="trlist.id">
          <td width="180">{{trlist.title}}</td>
          <td style="padding: 0px;">
            <template v-for="detaiTr in trlist.value" :key="detaiTr.id">
              <oa-audit-printing-children 
                :printingDataChil="detaiTr" 
                :printingDataChil2="printingDataChil2" 
                :printingDataChil3="printingType"
                @update:printingDataChil="(val) => detaiTr = val"
                @update:printingDataChil2="$emit('update:printingDataChil2', $event)"
                @update:printingDataChil3="$emit('update:printingDataChil3', $event)">
              </oa-audit-printing-children>
            </template>
          </td>
        </tr>
      </template>
      <template v-else-if="(trlist.type == 'relation-radio'&&trlist.print==1)||(trlist.type == 'new-rel-radio'&&trlist.print==1)" >
        <tr v-if="trlist.value.length!=0" :key="trlist.id">
          <td width="180">{{trlist.title}}</td>
          <td style="padding: 0px;">
            <oa-audit-printing-children 
              :printingDataChil="trlist.value" 
              :printingDataChil2="printingDataChil2" 
              :printingDataChil3="printingType"
              @update:printingDataChil="(val) => trlist.value = val"
              @update:printingDataChil2="$emit('update:printingDataChil2', $event)"
              @update:printingDataChil3="$emit('update:printingDataChil3', $event)">
            </oa-audit-printing-children>
          </td>
        </tr>
        <tr v-else :key="trlist.id">
          <td width="180">{{trlist.title}}</td>
          <td width="600">{{trlist.relName}}</td>
        </tr>
      </template>
      <tr v-else-if="trlist.type == 'checkbox'&&trlist.print==1" :key="trlist.id">
        <td width="180">{{trlist.title}}</td>
        <td v-if="trlist.value==''" align="center">
          （暂无数据）
        </td>
        <td v-else>
          <span v-for="tdlist in trlist.value" :key="tdlist.id" style="margin-right: 8px;">{{tdlist}}</span>
        </td>
      </tr>
      <tr v-else-if="['relation-user', 'organization', 'roule'].includes(trlist.type)&&trlist.print==1" :key="trlist.id">
        <td width="180">{{trlist.title}}</td>
        <td v-if="trlist.value==''" align="center">
          （暂无数据）
        </td>
        <td v-else>
          <span v-for="tdlist in trlist.value" :key="tdlist.id" style="margin-right: 8px;">{{tdlist.realname || tdlist.name}}</span>
        </td>
      </tr>
      <tr v-else-if="trlist.type == 'image'&&trlist.print==1" :key="trlist.id">
        <td width="180">{{trlist.title}}</td>
        <td v-if="trlist.value==''" align="center">
          （未上传）
        </td>
        <td v-else>
          <span v-for="tdlist in trlist.value"
                :key="tdlist"
                :style="{width: trlist.printWidth !== '100%' ? (trlist.printWidth + 'px') : '', height: (trlist.printHeight + 'px') || '', overflow:'hidden'}"
                class="td-span">
            <img :src="$url+tdlist+token"
                 :style="{maxWidth:'100%',maxHeight: '100%',width: trlist.printWidth !== '100%' ? (trlist.printWidth + 'px') : '',height: (trlist.printHeight + 'px') || ''}">
          </span>
        </td>
      </tr>
      <tr v-else-if="trlist.type == 'file'&&trlist.print==1" :key="trlist.id">
        <td width="180">{{trlist.title}}</td>
        <td v-if="trlist.value==''" align="center">
          （未上传）
        </td>
        <td v-else>
          <span v-for="tdlist in trlist.value" :key="tdlist.id" class="td-span">{{tdlist}}</span>
        </td>
      </tr>
      <tr v-else-if="trlist.type == 'textarea'&&trlist.print==1" :key="trlist.id">
        <td width="180">{{trlist.title}}</td>
        <td width="800" v-html="replaces(trlist.value)"></td>
      </tr>
      <tr v-else-if="trlist.type == 'richTextWid'&&trlist.print==1" :key="trlist.id">
        <td width="180">{{trlist.title}}</td>
        <td width="800" v-html="replaces(trlist.value)"></td>
      </tr>
      <tr v-else-if="trlist.type == 'relation-check' && trlist.print==1" :key="trlist.id">
        <td width="180">{{trlist.title}}</td>
        <td :style="getRelCheckbox(trlist.value) ? 'padding: 0px;' : ''">
          <template v-if="getRelCheckbox(trlist.value)">
            <table :border="printingDataChil3==1?1:0" rules="all" width="100%" class="relation-check">
              <template v-for="its in getRelCheckbox(trlist.value).data">
                <tr v-for="(ite, indexs) in getRelCheckbox(trlist.value).top" :key="its.title + '_' + indexs">
                  <td width="180">{{ ite.name }}</td>
                  <td>{{ its[ite.title] }}</td>
                </tr>
              </template>
            </table>
          </template>
          <template v-else>{{ trlist.value || trlist.value === 0 ? trlist.value : '暂无数据' }}</template>
        </td>
      </tr>
      <template v-else-if="trlist.type == 'ready-widget'&&trlist.print==1">
        <template v-for="reaW in trlist.value">
          <tr v-if="reaW.type == 'displaylist'" class="displaylist" :key="reaW.id">
            <td width="180">{{reaW.title}}</td>
            <td width="800">
              <label v-for="timeA in reaW.value" :key="timeA.id">
                <span>{{timeA.date}}</span>
                <span class="time-class">
                  {{timeArr[timeA.time[0]]}}
                  <span>-</span>
                  {{timeArr[timeA.time[1]+1]}}
                </span>
              </label>
            </td>
          </tr>
          <tr v-else-if="reaW.type == 'radio'&&trlist.print==1" :key="reaW.id">
            <td width="180">{{reaW.title}}</td>
            <td width="800">{{reaW.value}}</td>
          </tr>
        </template>
      </template>
      <tr v-else-if="trlist.print==1" :key="trlist.id">
        <td width="180">{{trlist.title}}</td>
        <td width="800">{{trlist.value}}</td>
      </tr>
    </template>
    <!--表尾-->
    <template v-if="printingDataChil3==1">
      <tr>
        <td width="180">处理流程</td>
        <td style="padding: 0px;">
          <table rules="all" width="100%">
            <tr v-for="tabletitle1 in printingDataChil2.processData" :key="tabletitle1.id">
              <td width="184">
                <p>{{tabletitle1.stateUser}}</p>
              </td>
              <td style="position: relative;">
                  <p>
                    {{tabletitle1.stateName}}
                    <span style="font-size: 14px;" v-if="tabletitle1.userText">{{tabletitle1.userText}}</span>
                  </p>
                  <img style="position:absolute;right:40px;height:40px;top:calc(50% - 20px)" v-if="tabletitle1.stateSignIs" :src="tabletitle1.stateSignIs" />
                  <p style="padding-top: 2px;" v-if="tabletitle1.stateMain!=''">
                    {{tabletitle1.stateMain}}
                  </p>
              </td>
              <td width="200"><p>{{tabletitle1.stateTime}}</p></td>
            </tr>
          </table>
        </td>
      </tr>
    </template>
  </table>
</template>

<script>
  import {formatDate, filesConfig} from "@/api/global.js";
  import {generateTime} from "../../api/utils.js";
  export default {
    name: "oa-audit-printing-children",
    // isTime 是否显示申请时间
    props: {
      printingDataChil: {},
      printingDataChil2: {},
      printingDataChil3: {},
      isTime: {},
      defaultPrintShowKey: {},
    },
    created() {
      this.timeArr = generateTime()
    },
    data(){
      return{
        printingType:2,
        timeArr:[],
        token: '?accesstoken='+filesConfig()
      }
    },
    methods: {
      // 关联多选新老格式判断
      getRelCheckbox (val) {
        if (typeof val === "object" && val.top && val.data) return val
        if (typeof val === 'string' && val[0] === '{') {
          try{
            val = JSON.parse(val)
            return val
          } catch(e) {
            return false
          }
        }
        return false
      },
      replaces(content) {
        try {
          return content.replace(/\n/g, "<br />");
        }
        catch (e) {
          return content;
        }
      },
      // 时间戳转成时间
      formatTimestamp(timestamp) {
        if (!timestamp) return '';
        const date = new Date(timestamp);
        return formatDate(date, "yyyy-MM-dd hh:mm");
      },
    }
  }
</script>

<style scoped>
  @import '../../../public/static/print/oaAuditPrinting.css';
</style>
